import { render, staticRenderFns } from "./SitesTermsEditor.vue?vue&type=template&id=10f009f8&scoped=true"
import script from "./SitesTermsEditor.vue?vue&type=script&lang=js"
export * from "./SitesTermsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f009f8",
  null
  
)

export default component.exports